import { Page, PageBody } from "@/components/app-layout";
import { HomeChat } from "@/components/chat/HomeChat";
import { ChatFileManagerProvider } from "@/components/file/ChatFileManager/ChatFileManagerContext";

export const GroupHomePage = () => {
  return (
    <Page className="bg-background-1">
      <PageBody>
        <div className="flex h-full w-full items-center justify-center py-10">
          <ChatFileManagerProvider
            groupUuid={undefined}
            kitUuid={null}
            chatUuid={null}
          >
            <HomeChat />
          </ChatFileManagerProvider>
        </div>
      </PageBody>
    </Page>
  );
};
